import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=386e12ca&scoped=true&"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js&"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdmin.vue?vue&type=style&index=0&id=386e12ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e12ca",
  null
  
)

export default component.exports